import { useBusinessContext } from '@root/context'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { fetchPermissionGroups } from '../constants'

export const usePermissionGroups = () => {
  const { slug } = useBusinessContext()

  return useQuery({
    queryKey: [slug, 'permissionGroups'],
    queryFn: () => fetchPermissionGroups({ slug }),
    ...{
      placeholderData: keepPreviousData,
      staleTime: 6 * 60 * 60 * 1000, // Adding stale time to 6 hours in ms to avoid refetching
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false
    }
  })
}
